import React from 'react';
import '../../../styles/dashboard/Announcements.css';
import tableData from './fakeData';

const TableLatestShort = ({
  setReadDetails,
  setDetailsID,
  setFormOpen,
  setSignClose,
  setAddNewForm
}) => {
  const handleDataClick = (id) => {
    setFormOpen(true);
    setReadDetails(true);
    setDetailsID(id);
    setSignClose(false);
    setAddNewForm(false);
  };
  return (
    <table className='table-announcement short-tables'>
      <thead className='thead'>
        <tr>
          <th scope='col'></th>
        </tr>
      </thead>
      {tableData.length > 0 ? (
        <tbody>
          {tableData.map((data, id) => {
            return (
              <tr key={id} onClick={() => handleDataClick(id)}>
                <td>{data.title}</td>
              </tr>
            );
          })}
        </tbody>
      ) : (
        <tbody>
          <p className='loading'>Loading Data...</p>
        </tbody>
      )}
    </table>
  );
};

export default TableLatestShort;
